import { IFavorite } from '../../../types/favorites';
import { ITypedReduxAction } from '../../../types/redux/actionType';

export enum EGetFavoritesListActionTypes {
  Initial = 'getFavoritesList/initial',
  Loading = 'getFavoritesList/loading',
  Succeed = 'getFavoritesList/succeed',
  Failed = 'getFavoritesList/failed',
}

export type TGetFavoritesListInitial = ITypedReduxAction<EGetFavoritesListActionTypes.Initial>;
export type TGetFavoritesListLoading = ITypedReduxAction<EGetFavoritesListActionTypes.Loading>;
export type TGetFavoritesListSucceed = ITypedReduxAction<EGetFavoritesListActionTypes.Succeed, IFavorite[]>;
export type TGetFavoritesListFailed = ITypedReduxAction<EGetFavoritesListActionTypes.Failed>;

export type TGetNotificationsList =
  | TGetFavoritesListInitial
  | TGetFavoritesListLoading
  | TGetFavoritesListSucceed
  | TGetFavoritesListFailed;
